(() => {
	'use strict';

	// Magic vars
	const rootClass = 'accordion__header';
	const activeClass = 'active';

	const handleAccordionClick = (e, elm) => {
		const section = elm.parentElement;
		if (!section.classList.contains(activeClass)) {
			section.classList.add(activeClass);
		} else {
			section.classList.remove(activeClass);
		}
	};

	// Set up each instance of the block
	document.querySelectorAll(`.${rootClass}`).forEach((rootEl) => {
		// Listen for accordion clicks
		rootEl.addEventListener('click', (event) => {
			handleAccordionClick(event, rootEl);
		});
	});
})();
